import { useParams, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import s from "./CategoryPage.module.css"

const CATEGORIES: Record<string, {
  title: string
  h1: string
  description: string
  keywords: string[]
  text: string
  emoji: string
  city?: string
}> = {
  // Категории по типу
  games: {
    title: "Игры в Москве — мафия, настолки, квизы | Tribe",
    h1: "Игры в Москве",
    description: "Афиша игровых событий в Москве. Мафия, настольные игры, квизы — находите и записывайтесь на Tribe.",
    keywords: ["мафия в Москве", "настольные игры Москва", "квиз Москва", "игры Москва"],
    emoji: "🎮",
    text: `Tribe — афиша игровых событий Москвы. Мафия, настолки, квизы и живые игры — всё в одном месте. Более 5000 событий только в Москве.

Мафия в Москве — один из самых популярных форматов: 6 255 человек ищут игру каждый месяц. Квизы собирают 13 000 запросов. Tribe помогает найти ближайшую игру и записаться за пару кликов.

Все события добавлены организаторами напрямую — актуальные даты, реальные места, живые люди.`
  },
  love: {
    title: "Мероприятия для знакомств в Москве | Tribe",
    h1: "Знакомства и общение в Москве",
    description: "Мероприятия для знакомств в Москве. Игры, вечеринки и встречи по интересам.",
    keywords: ["мероприятия для знакомств Москва", "где познакомиться Москва", "тусовки по интересам"],
    emoji: "❤️",
    text: `На Tribe вы найдёте мероприятия где знакомятся по-настоящему — в живой неформальной обстановке. Игры на знакомство, тематические вечеринки, встречи по интересам.

Никаких приложений для свайпов — только живое общение. Каждый день в Москве проходят десятки событий где можно встретить своих людей.`
  },
  parties: {
    title: "Вечеринки в Москве — афиша | Tribe",
    h1: "Вечеринки в Москве",
    description: "Афиша вечеринок в Москве. Куда пойти вечером и на выходных в Москве.",
    keywords: ["вечеринки Москва", "куда пойти вечером Москва", "досуг Москва выходные", "развлечения Москва"],
    emoji: "🎉",
    text: `Tribe — афиша лучших вечеринок Москвы. Тематические вечера, музыкальные события, арт-вечеринки и закрытые клубы по интересам.

Москва не спит — каждый вечер что-то происходит. Tribe помогает найти именно то событие которое запомнится. Более 5000 актуальных мероприятий.`
  },
  education: {
    title: "Мастер-классы и воркшопы в Москве | Tribe",
    h1: "Обучение в Москве",
    description: "Мастер-классы, воркшопы и образовательные события в Москве на Tribe.",
    keywords: ["мастер-классы Москва", "воркшопы Москва", "обучение Москва"],
    emoji: "📚",
    text: `На Tribe собраны мастер-классы и воркшопы от лучших специалистов Москвы. Творческие мастерские, профессиональные курсы, практические занятия в малых группах.

Учитесь новому в живой атмосфере — не онлайн, а в реальности рядом с вами.`
  },
  culture: {
    title: "Культурные события в Москве | Tribe",
    h1: "Культура в Москве",
    description: "Культурные события Москвы: выставки, театр, перформансы, литературные вечера на Tribe.",
    keywords: ["культурные события Москва", "выставки Москва", "театр Москва"],
    emoji: "🎭",
    text: `На Tribe — живая независимая культура Москвы. Авторские выставки, театральные постановки, поэтические вечера и кино-клубы.

Не mainstream, а настоящее искусство от людей для людей. Открывайте культурную жизнь Москвы которую не найти в обычных афишах.`
  },
  sport: {
    title: "Спортивные события в Москве | Tribe",
    h1: "Спорт в Москве",
    description: "Спортивные события Москвы: групповые тренировки, соревнования, спортивные клубы на Tribe.",
    keywords: ["спортивные события Москва", "групповые тренировки Москва", "спортивные клубы Москва"],
    emoji: "⚽",
    text: `На Tribe — групповые тренировки, любительские соревнования и спортивные клубы Москвы. Бег, йога, танцы, командные виды спорта.

Найдите единомышленников и начните двигаться — все события открыты для новичков.`
  },
  walking: {
    title: "Прогулки по Москве — экскурсии | Tribe",
    h1: "Прогулки по Москве",
    description: "Пешие экскурсии и прогулки по Москве на Tribe. Откройте город по-новому.",
    keywords: ["прогулки Москва", "экскурсии Москва", "прогулки по Москве"],
    emoji: "🚶",
    text: `Авторские экскурсии и прогулки по Москве — дворы которые знают только местные, исторические маршруты, арт-прогулки.

Небольшие группы, неформальное общение, настоящая Москва. Откройте город заново.`
  },

  // Городские лендинги
  moscow: {
    title: "Афиша Москвы — мероприятия и события | Tribe",
    h1: "Афиша Москвы",
    description: "Афиша событий и мероприятий в Москве. Куда пойти в Москве сегодня и на выходных — находите на Tribe.",
    keywords: ["афиша Москва", "мероприятия в Москве", "куда пойти в Москве", "мероприятия Москва сегодня", "куда пойти в Москве на выходных"],
    emoji: "🏙️",
    city: "Москва",
    text: `Tribe — это афиша живых событий Москвы. Более 5 000 актуальных мероприятий: игры, вечеринки, мастер-классы, культурные события, спорт и прогулки.

Каждый день в Москве происходит что-то интересное. Tribe помогает найти именно то что подходит вам — по дате, формату, интересам и району города.

Мероприятия в Москве на любой вкус: бесплатные и платные, для одного и компанией, утром и ночью. Все события добавлены организаторами напрямую — актуальные даты и реальные места.

Куда пойти в Москве сегодня? Откройте Tribe и найдите своё событие за 2 минуты.`
  },
  spb: {
    title: "Афиша Санкт-Петербурга — мероприятия и события | Tribe",
    h1: "Афиша Санкт-Петербурга",
    description: "Афиша событий и мероприятий в Санкт-Петербурге. Куда пойти в Петербурге — находите на Tribe.",
    keywords: ["афиша Санкт-Петербург", "мероприятия в Санкт-Петербурге", "куда пойти в Петербурге", "афиша СПб", "мероприятия СПб"],
    emoji: "🌉",
    city: "Санкт-Петербург",
    text: `Tribe — афиша живых событий Санкт-Петербурга. Более 3 500 актуальных мероприятий: игры, вечеринки, культурные события, мастер-классы и прогулки по городу.

Петербург — культурная столица России. Здесь каждый день что-то происходит: авторские выставки, музыкальные вечера, тематические игры, нетворкинг и много другого.

Tribe собирает все живые события Петербурга в одном месте. Находите мероприятия по интересам, записывайтесь и встречайте своих людей.`
  },
  ekb: {
    title: "Афиша Екатеринбурга — мероприятия и события | Tribe",
    h1: "Афиша Екатеринбурга",
    description: "Афиша событий и мероприятий в Екатеринбурге. Куда пойти в Екатеринбурге — находите на Tribe.",
    keywords: ["афиша Екатеринбург", "мероприятия в Екатеринбурге", "куда пойти в Екатеринбурге", "события Екатеринбург"],
    emoji: "🏔️",
    city: "Екатеринбург",
    text: `Tribe — афиша живых событий Екатеринбурга. Более 800 актуальных мероприятий: игры, вечеринки, мастер-классы, культурные события и спорт.

Екатеринбург — один из самых активных городов России. На Tribe вы найдёте события на любой вкус: от камерных игровых вечеров до масштабных городских мероприятий.

Все события добавлены организаторами напрямую — актуальные даты, реальные места, живые люди.`
  },
  novosibirsk: {
    title: "Афиша Новосибирска — мероприятия и события | Tribe",
    h1: "Афиша Новосибирска",
    description: "Афиша событий и мероприятий в Новосибирске. Куда пойти в Новосибирске — находите на Tribe.",
    keywords: ["афиша Новосибирск", "мероприятия в Новосибирске", "куда пойти в Новосибирске", "события Новосибирск"],
    emoji: "🌲",
    city: "Новосибирск",
    text: `Tribe — афиша живых событий Новосибирска. Более 800 актуальных мероприятий: игры, вечеринки, мастер-классы и культурные события.

Новосибирск — третий город России с яркой культурной жизнью. На Tribe собраны все живые события города в одном месте.`
  },
  kazan: {
    title: "Афиша Казани — мероприятия и события | Tribe",
    h1: "Афиша Казани",
    description: "Афиша событий и мероприятий в Казани. Куда пойти в Казани — находите на Tribe.",
    keywords: ["афиша Казань", "мероприятия в Казани", "куда пойти в Казани", "афиша мероприятий Казань", "события Казань"],
    emoji: "🕌",
    city: "Казань",
    text: `Tribe — афиша живых событий Казани. Игры, вечеринки, мастер-классы и культурные мероприятия — всё в одном месте.

Казань — один из самых динамичных городов России. На Tribe вы найдёте актуальные события для жителей и гостей города.`
  },
  krasnodar: {
    title: "Афиша Краснодара — мероприятия и события | Tribe",
    h1: "Афиша Краснодара",
    description: "Афиша событий и мероприятий в Краснодаре. Куда пойти в Краснодаре — находите на Tribe.",
    keywords: ["афиша Краснодар", "мероприятия в Краснодаре", "куда пойти в Краснодаре", "события Краснодар"],
    emoji: "🌻",
    city: "Краснодар",
    text: `Tribe — афиша живых событий Краснодара. Игры, вечеринки, мастер-классы и активный досуг в солнечном Краснодаре.

Более 370 актуальных мероприятий от организаторов напрямую.`
  },
  rostov: {
    title: "Афиша Ростова-на-Дону — мероприятия | Tribe",
    h1: "Афиша Ростова-на-Дону",
    description: "Афиша событий и мероприятий в Ростове-на-Дону на Tribe.",
    keywords: ["афиша Ростов-на-Дону", "мероприятия Ростов", "куда пойти в Ростове", "события Ростов"],
    emoji: "🌊",
    city: "Ростов-на-Дону",
    text: `Tribe — афиша живых событий Ростова-на-Дону. Более 420 актуальных мероприятий: игры, вечеринки и культурные события.`
  },
  kaliningrad: {
    title: "Афиша Калининграда — мероприятия | Tribe",
    h1: "Афиша Калининграда",
    description: "Афиша событий и мероприятий в Калининграде на Tribe.",
    keywords: ["афиша Калининград", "мероприятия Калининград", "куда пойти в Калининграде"],
    emoji: "⚓",
    city: "Калининград",
    text: `Tribe — афиша живых событий Калининграда. Более 200 актуальных мероприятий в самом западном городе России.`
  }
}

const CategoryPage = ({ city }: { city?: string }) => {
  const { slug } = useParams<{ slug: string }>()
  const navigate = useNavigate()
  const key = city || slug
  const category = key ? CATEGORIES[key] : null

  useEffect(() => {
    if (category) {
      document.title = category.title
      const meta = document.querySelector('meta[name="description"]')
      if (meta) meta.setAttribute('content', category.description)
    }
  }, [category])

  if (!category) {
    navigate('/')
    return null
  }

  return (
    <div className={s.page}>
      <div className={s.hero}>
        <div className={s.emoji}>{category.emoji}</div>
        <h1 className={s.h1}>{category.h1}</h1>
        <p className={s.desc}>{category.description}</p>
        <div className={s.keywords}>
          {category.keywords.map(kw => (
            <span key={kw} className={s.kw}>{kw}</span>
          ))}
        </div>
        <button className={s.cta} onClick={() => navigate('/')}>
          Смотреть события →
        </button>
      </div>
      <div className={s.text}>
        {category.text.split('\n\n').map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    </div>
  )
}

export default CategoryPage
